import { AbstractStakeData } from "@lib/titan2/dist/api/common/model/data/AbstractStakeData";
import { SlingoConstants } from "../enum/SlingoConstants";
/*
 * StakeConfigData.ts
 */
export class StakeConfigData extends AbstractStakeData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.amounts = this.data.getNumberArray(SlingoConstants.PROPERTY_STAKE_AMOUNTS);
            this.index = this.data.getNumber(SlingoConstants.PROPERTY_STAKE_DEFAULT_INDEX);
            this.defaultIndex = this.index;
            this.changed = false;
        }
    }
}
//# sourceMappingURL=StakeConfigData.js.map